import React from 'react'
import './InnerBanner.css'
import { Col, Container, Row } from 'react-bootstrap'

const InnerBanner = ({heading}) => {
  return (
    <section className="inner-banner">
        <Container>
            <Row>
                <Col xs={12} className="text-center">
                    <h1 className='banner-heading'>{heading}</h1>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default InnerBanner
